module.exports = __webpack_public_path__ + "static/media/Stephanie Parey.27081c29.png";